<nav class="fixed top-0 left-0 right-0 z-50 flex items-center gap-6 px-6 h-14">
  <a
    class="flex items-center gap-1 no-underline hover:no-underline shrink-0"
    [routerLink]="companyService.activeCompany() ? ['/', companyService.activeCompany()!.slug, 'campaigns'] : ['/']"
  >
    <span class="nav-logo-text font-bold text-base tracking-tight">webout</span><span class="font-bold text-base tracking-tight text-[var(--wb-text-muted)]">.</span><span class="font-semibold text-base tracking-tight text-[var(--wb-text)]">platform</span>
  </a>

  @if (!auth.loading() && auth.isAuthenticated()) {
    @if (companyService.companies().length > 1) {
      <p-select
        [options]="companyService.companies()"
        [ngModel]="companyService.activeCompany()?.slug"
        (ngModelChange)="switchCompany($event)"
        optionLabel="name"
        optionValue="slug"
        appendTo="body"
        styleClass="nav-company-select"
      />
    }
    <ul class="nav-links flex gap-1 list-none m-0 p-0">
      @if (companyService.activeCompany(); as company) {
        <li>
          <a
            [routerLink]="['/', company.slug, 'campaigns']"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            class="nav-link"
          >
            <i class="pi pi-th-large text-[0.8rem]"></i> Campaigns
          </a>
        </li>
        @if (activeCampaignSlug(); as campaignSlug) {
          <li class="nav-crumb-sep" aria-hidden="true">
            <i class="pi pi-chevron-right"></i>
          </li>
          <li>
            <a
              [routerLink]="['/', company.slug, 'campaigns', campaignSlug]"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              class="nav-link"
            >
              {{ activeCampaign()?.name ?? campaignSlug }}
            </a>
          </li>
        }
      }
      @if (auth.user()?.isAdmin) {
        <li>
          <a routerLink="/admin" routerLinkActive="active" class="nav-link">
            <i class="pi pi-cog text-[0.8rem]"></i> Admin
          </a>
        </li>
      }
    </ul>
  }

  <div class="ml-auto flex items-center gap-2">
    @if (!auth.loading() && auth.isAuthenticated()) {
      <a routerLink="/profile" class="nav-user-name" title="Profile">{{ auth.user()?.name }}</a>
      <button
        class="nav-theme-toggle"
        (click)="auth.logout()"
        aria-label="Sign out"
        title="Sign out"
      >
        <i class="pi pi-sign-out text-base"></i>
      </button>
    }
    <button
      class="nav-theme-toggle"
      (click)="themeService.toggle()"
      [attr.aria-label]="themeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      <i class="pi text-base" [class.pi-sun]="themeService.isDark()" [class.pi-moon]="!themeService.isDark()"></i>
    </button>
  </div>
</nav>
<!-- Spacer to offset fixed nav height -->
<div class="h-14"></div>
